import { useState } from 'react';
import { uploadImage, deleteImage } from '../utils/ossClient';

export const useImageUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const upload = async (file: File): Promise<string | null> => {
    setUploading(true);
    setError(null);
    
    try {
      const url = await uploadImage(file);
      return url;
    } catch (err) {
      setError('Failed to upload image');
      console.error('Upload error:', err);
      return null;
    } finally {
      setUploading(false);
    }
  };

  const remove = async (url: string): Promise<boolean> => {
    try {
      await deleteImage(url);
      return true;
    } catch (err) {
      setError('Failed to delete image');
      console.error('Delete error:', err);
      return false;
    }
  };

  return { upload, remove, uploading, error };
};
